import React from 'react';
import querystring from 'querystring';

import { Main, MainHeader, Body } from 'components/Main';
import { Panel, PanelTop } from 'components/Panel';
import ResultLink from 'components/ResultLink';
import { Table, Th, Td } from 'components/Table';
import { dateRows } from 'components/util';

export default class FixturesPage extends React.Component {
    componentDidMount() {
        if (window !== undefined) {
            window.addEventListener('popstate', event => {
                let params = {};
                if (window.location.search) {
                    params = querystring.parse(window.location.search.substring(1));
                }
                this.props.browserBack(window.location.pathname, params);
            });
        }
    }

    render() {
        const { fixtures, opposition } = this.props;
        let title = 'Fixtures';
        let searchTitle;
        if (opposition) {
            title = 'Fixtures Search';
            searchTitle = <h2>{opposition}</h2>;
        }
        return (
            <Main>
                <MainHeader />
                <Body id="fixtures-page">
                    <Panel border>
                        <PanelTop title={title} buttons>
                            {searchTitle}
                        </PanelTop>
                        <FixturesTable fixtures={fixtures} />
                    </Panel>
                </Body>
            </Main>
        );
    }
}

export const FixturesTable = ({ fixtures }) => (
    <Table hover>
        <thead>
            <tr>
                <Th min="3" left>
                    Date
                </Th>
                <Th min="3">Team</Th>
                <Th min="3" center />
                <Th left>Opposition</Th>
                <Th className="cc-1l">Start</Th>
                <Th className="cc-1l" left>
                    Location
                </Th>
                <Th className="cc-1l" left>
                    Type
                </Th>
                <Th min="3" priority="2" left />
            </tr>
        </thead>
        <tbody>
            {dateRows(fixtures, 6, (fixture, longDate, shortestDate, rowClassName) => (
                <FixtureRow
                    key={fixture.mid}
                    fixture={fixture}
                    longDate={longDate}
                    shortestDate={shortestDate}
                    rowClassName={rowClassName}
                />
            ))}
        </tbody>
    </Table>
);

const FixtureRow = ({ fixture, rowClassName, longDate, shortestDate }) => {
    let opposition = fixture.opposition;
    if (fixture.url) {
        opposition = (
            <a href={fixture.url} target="_new">
                {opposition}
            </a>
        );
    }
    let details = `${fixture.time} - ${fixture.location} (${fixture.type})`;
    let result;
    if (fixture.result) {
        details = `${fixture.location} (${fixture.type})`;
        result = <ResultLink fixture={fixture} rolloverDirection="left" />;
    }
    return (
        <tr className={rowClassName}>
            <Td min="3" short="5" value={shortestDate} left>
                {longDate}
            </Td>
            <Td min="3" short="3" value={fixture.sname}>
                <a href={`/teams/${fixture.link_date}`}>{fixture.lname}</a>
            </Td>
            <Td min="3" center>
                v
            </Td>
            <Td ellipsis="3" left>
                {opposition}
            </Td>
            <Td className="cc-text-weak cc-1l">{fixture.time}</Td>
            <Td className="cc-text-weak cc-1l" left>
                {fixture.location}
            </Td>
            <Td className="cc-text-weak cc-1l" left>
                {fixture.type}
            </Td>
            <Td min="3" priority="2" left>
                <div className="cc-text-weak cc-text-small cc-2l">{details}</div>
                {result}
            </Td>
        </tr>
    );
};



// WEBPACK FOOTER //
// ./src/views/fixtures/FixturesPage.jsx